import React from "react";
import { Typography, Grid, Chip, ListItemText, ListItem, List, Box } from "@mui/material";
import { format } from "date-fns";

const SelectedTaskDetails = ({ selectedTask }) => {
  if (!selectedTask) return null;
  return (
    <>
      {/* Task Title */}
      <Typography sx={{ fontWeight: "bold", fontSize: "16px", color: "black", mb: 1 }}>
        {selectedTask.taskName}
      </Typography>

      {/* Task Status */}
      <Grid container spacing={1} alignItems='center' sx={{ mb: 2 }}>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <Typography sx={{ fontSize: "14px" }}>Status</Typography>
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <Chip
            variant='contained'
            sx={{
              fontSize: "12px",
              borderRadius: 5,
              backgroundColor: selectedTask.status === "completed" ? "#EAFFF2" : "#F2F6FF",
              color: selectedTask.status === "completed" ? "green" : "blue",
            }}
            label={selectedTask.status}
            size='small'
          />
        </Grid>
      </Grid>

      {/* Shift */}
      <Grid container spacing={1} alignItems='center' sx={{ mb: 2 }}>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <Typography sx={{ fontSize: "14px" }}>Shift</Typography>
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <Typography variant='body2'>{selectedTask.shiftType}</Typography>
        </Grid>
      </Grid>

      {/* Date Completed */}
      <Grid container spacing={1} alignItems='center' sx={{ mb: 2 }}>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <Typography sx={{ fontSize: "14px" }}>Date Completed</Typography>
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <Typography variant='body2'>
            {selectedTask.status === "completed"
              ? format(new Date(selectedTask.updated_at), "dd MMM yyyy")
              : "Not completed"}
          </Typography>
        </Grid>
      </Grid>

      {/* Assignee */}
      <Grid container spacing={1} alignItems='center' sx={{ mb: 2 }}>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <Typography sx={{ fontSize: "14px" }}>Assignee</Typography>
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <Typography variant='body2'>{selectedTask.assignee}</Typography>
        </Grid>
      </Grid>

      {/* Description */}
      <Typography sx={{ fontSize: "14px", mb: 1 }}>Description</Typography>
      <Typography
        variant='body2'
        sx={{
          p: 1,
          borderRadius: 2,
        }}
      >
        {selectedTask.description}
      </Typography>
      <Box sx={{ padding: "16px", borderRadius: "8px" }}>
        {/* Header */}
        <Grid container>
          <Grid item lg={9} md={9} sm={9} xs={12}>
            <Typography sx={{ fontSize: "14px", color: "black" }}>Sub tasks</Typography>
          </Grid>
          <Grid item lg={3} md={3} sm={3} xs={12}>
            <Typography sx={{ fontSize: "14px" }}>{`${
              selectedTask.checklist ? selectedTask.checklist.length : 0
            } tasks`}</Typography>
          </Grid>
        </Grid>

        {/* Subtasks */}
        <List>
          {selectedTask.checklist && selectedTask.checklist.length > 0 ? (
            selectedTask.checklist.map((subtask, index) => (
              <ListItem
                key={index}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "8px 0",
                }}
              >
                <ListItemText
                  primary={subtask.item}
                  primaryTypographyProps={{
                    sx: {
                      fontSize: "12px",
                      color: "black",
                      textDecoration: subtask.completed ? "line-through" : "none",
                    },
                  }}
                />
                <Typography sx={{ fontSize: "12px", color: "black" }}>
                  {selectedTask.updated_by ?? "Not Completed"}
                </Typography>
              </ListItem>
            ))
          ) : (
            <Typography>No subtasks available.</Typography>
          )}
        </List>
      </Box>
    </>
  );
};

export default SelectedTaskDetails;
